import React, { Component } from 'react';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import IconButton from '@mui/material/IconButton';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import InputMask from 'react-input-mask';
import PropTypes from 'prop-types';

class DateRangeField extends Component {
    constructor(props) {
        super(props);

        this.fromPickerRef = React.createRef();
        this.toPickerRef = React.createRef();
    }

    formatDisplayDate = (value) => {
        if (!value) return '';
        const parts = value.split('-');
        if (parts.length !== 3) return '';
        return `${parts[2]}/${parts[1]}/${parts[0]}`;
    };

    convertToApiDate = (value) => {
        if (!value || value.length !== 10) return '';
        const parts = value.split('/');
        if (parts.length !== 3) return '';
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
    };

    openNativeDatePicker = (ref) => {
        const picker = ref && ref.current;
        if (!picker) {
            return;
        }
        if (typeof picker.showPicker === 'function') {
            picker.showPicker();
        } else {
            picker.click();
        }
    };

    handleDateChange = (fieldType, value) => {
        const { onFromChange, onToChange } = this.props;
    
        if (fieldType === 'from') {
            onFromChange(value);
        } else {
            onToChange(value);
        }
    };
    renderMaskedDateInput = (value, inputRef, placeholder, fieldType) => {

        return (
            <div style={{ position: 'relative', flex: 1 }}>
                <InputMask
                    mask="99/99/9999"
                    value={this.formatDisplayDate(value)}
                    onChange={(e) =>
                        this.handleDateChange(fieldType, this.convertToApiDate(e.target.value))
                    }
                >
                    {(inputProps) => (
                        <TextField
                        {...inputProps}
                        fullWidth
                        variant="outlined"
                        size="small"
                        placeholder={placeholder || 'gg/aa/yyyy'}
                        style={{
                            minHeight: 36,
                            fontSize: 15
                        }}
                        sx={{
                            backgroundColor: '#fff',
                            '& .MuiInputBase-input': {
                                color: 'rgba(0,0,0,0.6)',
                                fontSize: 15,
                                padding: '8.5px 14px'
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: 'rgba(0,0,0,0.23)'
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: 'rgba(0,0,0,0.87)'
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#1976d2'
                            }
                        }}
                        InputProps={{
                            endAdornment: (
                                <IconButton
                                    size="small"
                                    onClick={() => this.openNativeDatePicker(inputRef)}
                                >
                                    <CalendarTodayIcon style={{ fontSize: 18, color: '#777' }} />
                                </IconButton>
                            )
                        }}
                    />
                    )}
                </InputMask>

                <input
                    ref={inputRef}
                    type="date"
                    value={value || ''}
                    onChange={(e) => this.handleDateChange(fieldType, e.target.value)}
                    style={{
                        position: 'absolute',
                        left: 0,
                        top: 'calc(100% + 8px)',
                        opacity: 0,
                        width: 1,
                        height: 1,
                        border: 0,
                        padding: 0
                    }}
                />
            </div>
        );
    };

    render() {
        const {
            label,
            fromValue,
            toValue,
            fromPlaceholder,
            toPlaceholder,
            labelStyle,
            separator
        } = this.props;

        return (
            <div>
                <InputLabel style={labelStyle || { marginBottom: 4, fontSize: 13 }}>
                    {label}
                </InputLabel>

                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    {this.renderMaskedDateInput(
                        fromValue,
                        this.fromPickerRef,
                        fromPlaceholder,
                        'from'
                    )}

                    <span
                        style={{
                            fontSize: 16,
                            color: '#777',
                            minWidth: 10,
                            textAlign: 'center'
                        }}
                    >
                        {separator || '-'}
                    </span>

                    {this.renderMaskedDateInput(
                        toValue,
                        this.toPickerRef,
                        toPlaceholder,
                        'to'
                    )}
                </div>
            </div>
        );
    }
}
DateRangeField.propTypes = {
    label: PropTypes.string,
    fromValue: PropTypes.string,
    toValue: PropTypes.string,
    fromPlaceholder: PropTypes.string,
    toPlaceholder: PropTypes.string,
    labelStyle: PropTypes.object,
    separator: PropTypes.string,
    onFromChange: PropTypes.func.isRequired,
    onToChange: PropTypes.func.isRequired
};

export default DateRangeField;